import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/Button/Button';
import { collaborationAPI } from '../../api/collaboration';
import './InvitePage.css';

export const InvitePage: React.FC = () => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleAcceptInvitation = async () => {
    if (!token) {
      setError(t('invitation.invalid'));
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await collaborationAPI.acceptInvitation(token);
      setSuccess(true);
      
      console.log(t('invitation.accepted'), result);
      
      // 3秒後にダッシュボードにリダイレクト
      setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 3000);
    } catch (err) {
      console.error('invitation error:', err);
      setError(err instanceof Error ? err.message : t('invitation.failed'));
      
      // トークンが無効またはすでに使用済みの場合はその旨を表示
      if (err instanceof Error && 
          (err.message.includes('invalid') || 
           err.message.includes('expired') ||
           err.message.includes('already'))) {
        setError(t('invitation.invalidOrExpired'));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = () => {
    navigate('/dashboard');
  };

  if (!token) {
    return (
      <div className="invite-page">
        <div className="invite-card invite-card--error">
          <div className="invite-icon">❌</div>
          <h1>{t('invitation.invalidTitle')}</h1>
          <p>{t('invitation.invalidDescription')}</p>
          <Button onClick={() => navigate('/dashboard')}>
            {t('invitation.backToDashboard')}
          </Button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="invite-page">
        <div className="invite-card invite-card--success">
          <div className="invite-icon">✅</div>
          <h1>{t('invitation.acceptedTitle')}</h1>
          <p>{t('invitation.acceptedDescription')}</p>
          <p className="redirect-message">
            {t('invitation.redirecting')}
          </p>
          <Button onClick={() => navigate('/dashboard')}>
            {t('invitation.goToDashboard')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="invite-page">
      <div className="invite-card">
        <div className="invite-icon">📧</div>
        <h1>{t('invitation.title')}</h1>
        <p>
          {t('invitation.description')}
          <br />
          {t('invitation.acceptQuestion')}
        </p>

        {error && (
          <div className="error-message">
            <div className="error-icon">⚠️</div>
            <p>{error}</p>
          </div>
        )}

        <div className="invite-actions">
          <Button
            variant="primary"
            onClick={handleAcceptInvitation}
            disabled={loading}
          >
            {loading ? t('invitation.processing') : t('invitation.accept')}
          </Button>
          <Button
            variant="ghost"
            onClick={handleDecline}
            disabled={loading}
          >
            {t('invitation.decline')}
          </Button>
        </div>

        <div className="invite-info">
          <h3>{t('invitation.capabilitiesTitle')}</h3>
          <ul>
            <li>{t('invitation.capability1')}</li>
            <li>{t('invitation.capability2')}</li>
            <li>{t('invitation.capability3')}</li>
            <li>{t('invitation.capability4')}</li>
            <li>{t('invitation.capability5')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
